class BlockedUserResponse {
    constructor(user_Id, block_Id, name) {
        this.user_Id = user_Id;
        this.block_Id = block_Id;
        this.name = name;
        // Mapping block_Id to userId because the UI logic in Settingspage.js uses .userId
        this.userId = block_Id;
    }

    static fromJson(json) {
        return new BlockedUserResponse(
            json.user_Id,
            json.block_Id,
            json.name
        );
    }
}

export default BlockedUserResponse;